import moment from "moment";
import "moment-timezone";
import { SENTIMENT_ACTION } from "./actions";
import { IData } from "../web/common";

const DATA_COUNT = 50;
const COLLECTION_NAME = "NS_CRP_SIGNALS_30";

interface IXUData {
  worst30: { Basket: string[]; Outgoing: []; Incoming: []; Index: number };
  requested: boolean;
  loaded: boolean;
}

const initialState: IXUData = {
  worst30: {} as any,
  requested: false,
  loaded: false,
};

export function loadWorst30(firebase: any, period: number) {
  if (period < 0 || ![0, 10, 30, 99].includes(period)) {
    console.log("Invalid period for signal 30. Period:", period);
    return async function thunk(dispatch: any, getState: any) {
      dispatch({
        type: SENTIMENT_ACTION.EMPTY_ACTION,
        payload: {},
      });
    };
  }

  return async function thunk(dispatch: any, getState: any) {
    const state = getState();
    if (state.Worst30.requested) return;
    dispatch({
      type: SENTIMENT_ACTION.WORST_30,
      payload: { requested: true, loaded: false, sentiment: [] },
    });
    let ix = 0;
    firebase
      .firestore()
      .collection(`${COLLECTION_NAME}_P${period}`)
      .where("reverse", "==", 1)
      .orderBy("dateTime", "desc")
      .limit(DATA_COUNT)
      .onSnapshot((querySnapshot: any) => {
        let data: Object[] = [];
        querySnapshot.forEach(function (doc: any) {
          data.push({
            key: ix++,
            name: "worst",
            Basket: doc.data().basket ?? [],
            Outgoing: doc.data().outgoing ?? [],
            Index: doc.data().index,
            Incoming: doc.data().incoming ?? [],
            Time: doc.data().time ?? 0,
            Date: moment(doc.data().dateTime.toDate())
              //.zone(0)
              .format("DD.MM.YY HH:mm"),
          });
        });

        dispatch({
          type: SENTIMENT_ACTION.WORST_30,
          payload: {
            worst30: data,
            loaded: true,
            requested: true,
          },
        });
      });
  };
}

export default function Worst30(state = initialState, action: any) {
  switch (action.type) {
    case SENTIMENT_ACTION.WORST_30:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
export const worst30Selector = (state: any) => state.Worst30;
